import Component from '@glimmer/component';
import { dateStringLongMonthDay } from 'mewe/utils/datetime-utils';

export default class SubscriptionTrialEnds extends Component {
  get trialEndDate() {
    const endsAtDate = new Date(this.args.notification.subscription.endsAt);
    return dateStringLongMonthDay(endsAtDate);
  }
}
